var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item"},[(_vm.itemLabel)?_c('p',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.itemLabel))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }